export default __webpack_public_path__ + "static/banner-eb34a8e2deca9fc6e5ee83d7865bfb2d.jpg";